import React from "react";

export default function AllSentencesList({ cards, isMuted }) {
  const handlePlay = (card) => {
    if (!isMuted && card.answerAudio) {
      const audio = new Audio(`/audio/${card.answerAudio}`);
      audio.play();
    }
  };

  return (
    <div className="all-sentences-list">
      <h2>All Sentences</h2>
      <ul>
        {cards.map((card, index) => (
          <li key={index} style={{ marginBottom: "1rem" }}>
            <strong>{card.text?.question}</strong>
            <p>{card.text?.answer}</p>
            <button onClick={() => handlePlay(card)}>▶</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
